
{
  "metadata": {
    "name": "NL Rivers",
    "country": "Netherlands",
    "count": 8,
    "description": "Nederlandse rivieren en hoofdwaterwegen als polylines (WGS84). Coordinaten zijn [lon, lat]. Geschikt voor map_locate_line vragen. Punten zijn vereenvoudigd (6-12 per rivier) maar volgen de werkelijke loop.",
    "coordinateFormat": "[lon, lat]"
  },
  "rivers": [
    {
      "id": "NL-RIJN",
      "name": "Rijn",
      "description": "Komt Nederland binnen bij Lobith en splitst zich in Waal, Nederrijn en IJssel.",
      "path": [
        [6.094, 51.866],
        [6.020, 51.890],
        [5.967, 51.913],
        [5.910, 51.945]
      ]
    },
    {
      "id": "NL-WAAL",
      "name": "Waal",
      "description": "Zuidelijke hoofdtak van de Rijn, stroomt door Nijmegen, Tiel en Gorinchem richting Rotterdam.",
      "path": [
        [5.910, 51.945],
        [5.842, 51.870],
        [5.755, 51.851],
        [5.602, 51.860],
        [5.428, 51.882],
        [5.234, 51.872],
        [5.083, 51.870],
        [4.974, 51.834],
        [4.806, 51.823],
        [4.640, 51.836],
        [4.490, 51.880],
        [4.392, 51.917]
      ]
    },
    {
      "id": "NL-NEDERRIJN-LEK",
      "name": "Nederrijn en Lek",
      "description": "Noordelijke tak van de Rijn die via Arnhem, Wijk bij Duurstede (waar de Lek begint) en Schoonhoven naar Rotterdam stroomt.",
      "path": [
        [5.910, 51.945],
        [5.880, 51.972],
        [5.847, 51.985],
        [5.752, 51.997],
        [5.600, 51.997],
        [5.467, 51.985],
        [5.336, 51.973],
        [5.190, 51.978],
        [5.024, 51.974],
        [4.866, 51.954],
        [4.692, 51.927],
        [4.530, 51.916]
      ]
    },
    {
      "id": "NL-IJSSEL",
      "name": "IJssel",
      "description": "Noordelijke tak van de Rijn, stroomt langs Doesburg, Zutphen, Deventer en Kampen naar het IJsselmeer.",
      "path": [
        [5.967, 51.913],
        [6.022, 51.960],
        [6.130, 52.018],
        [6.180, 52.140],
        [6.190, 52.245],
        [6.158, 52.348],
        [6.075, 52.450],
        [5.952, 52.520],
        [5.910, 52.566]
      ]
    },
    {
      "id": "NL-MAAS",
      "name": "Maas",
      "description": "Komt vanuit Belgi\u00eb het land binnen bij Eijsden, stroomt langs Maastricht, Roermond, Venlo, Den Bosch en mondt uit in het Hollands Diep.",
      "path": [
        [5.706, 50.776],
        [5.690, 50.846],
        [5.731, 50.917],
        [5.832, 51.005],
        [5.940, 51.117],
        [6.020, 51.197],
        [6.106, 51.380],
        [6.150, 51.500],
        [5.940, 51.685],
        [5.700, 51.748],
        [5.470, 51.756],
        [5.290, 51.730],
        [5.066, 51.738],
        [4.876, 51.740],
        [4.692, 51.730],
        [4.520, 51.706]
      ]
    },
    {
      "id": "NL-WESTERSCHELDE",
      "name": "Westerschelde",
      "description": "Brede zeearm in Zeeland, het laatste deel van de Schelde voor de Noordzee.",
      "path": [
        [4.244, 51.412],
        [3.928, 51.380],
        [3.764, 51.408],
        [3.585, 51.426],
        [3.412, 51.450],
        [3.244, 51.486],
        [3.072, 51.516]
      ]
    },
    {
      "id": "NL-EEMS",
      "name": "Eems",
      "description": "Grensrivier en zeearm in het noordoosten van Groningen, vormt de grens met Duitsland.",
      "path": [
        [7.000, 53.073],
        [7.050, 53.190],
        [7.075, 53.290],
        [7.060, 53.380],
        [6.972, 53.467]
      ]
    },
    {
      "id": "NL-VECHT-OV",
      "name": "Overijsselse Vecht",
      "description": "Stroomt vanuit Duitsland via Hardenberg, Ommen en Dalfsen naar Zwolle en het Zwarte Water.",
      "path": [
        [6.755, 52.532],
        [6.620, 52.560],
        [6.479, 52.582],
        [6.343, 52.582],
        [6.198, 52.553],
        [6.087, 52.519]
      ]
    }
  ]
}
